import { Outlet, NavLink } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { usePlatformLogout } from '@/hooks/usePlatformAuth'
import { usePendingPackPurchasesQuery } from '@/hooks/usePlatformPacks'

export default function PlatformLayout() {
  const logout = usePlatformLogout()
  const { data: pendingPacks = [] } = usePendingPackPurchasesQuery()

  return (
    <div className='min-h-screen'>
      <div className='border-b bg-background'>
        <div className='mx-auto flex max-w-6xl items-center justify-between px-4 py-3'>
          <div className='flex items-center gap-4'>
            <div className='flex flex-row items-center gap-3'>
              <img
                src='/logo_mogesapp_light.png'
                alt='MOGESAPP'
                className='h-8 w-8 dark:hidden'
                loading='eager'
              />
              {/* Mode sombre */}
              <img
                src='/logo_mogesapp_dark.png'
                alt='MOGESAPP'
                className='h-8 w-8 hidden dark:block'
                loading='eager'
              />
              <h1 className='font-bold text-primary text-2xl'>MOGESAPP</h1>
            </div>
            <nav className='flex items-center gap-3 text-sm text-muted-foreground'>
              <NavLink
                to='/platform'
                end
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                Owners
              </NavLink>
              <NavLink
                to='/platform/audit'
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                Audit
              </NavLink>
              <NavLink
                to='/platform/admins'
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                Admins
              </NavLink>
              <NavLink
                to='/platform/packs'
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                <span className='flex items-center gap-1'>
                  Packs
                  {pendingPacks.length > 0 && (
                    <span className='bg-destructive text-destructive-foreground text-xs rounded-full px-1.5 py-0.5 leading-none'>
                      {pendingPacks.length}
                    </span>
                  )}
                </span>
              </NavLink>
              <NavLink
                to='/platform/campaigns'
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                Campagnes
              </NavLink>
              <NavLink
                to='/platform/registration-blocks'
                className={({ isActive }) =>
                  isActive ? 'text-foreground font-medium' : ''
                }
              >
                Liste noire
              </NavLink>
            </nav>
          </div>
          <Button variant='outline' onClick={logout}>
            Logout
          </Button>
        </div>
      </div>

      <div className='mx-auto max-w-6xl px-4 py-6'>
        <Outlet />
      </div>
    </div>
  )
}
